export default "__VITE_ASSET__CarJ2_Tb__"